import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../reducers/types";
import {
  getFirstIndexOfHomesInAvailabilityLodgingsResults,
  getHasSeenStaysFilterFtux,
  getHotelAvailabilityLodgingsHasHomesAndHotels,
} from "../../reducer/selectors";
import { ManagedStayTypeFilterPopover } from "./component";
import { Dispatch } from "@reduxjs/toolkit";
import { actions } from "../../actions";

interface IStateProps {
  availabilityResultsHasHomesAndHotels: boolean;
  availabilityResultsFirstIndexOfHomeResult: number;
  canShow: boolean;
}

const mapStateToProps = (state: IStoreState) => {
  return {
    availabilityResultsHasHomesAndHotels:
      getHotelAvailabilityLodgingsHasHomesAndHotels(state),
    availabilityResultsFirstIndexOfHomeResult:
      getFirstIndexOfHomesInAvailabilityLodgingsResults(state),
    canShow: getHasSeenStaysFilterFtux(state) === false,
  };
};

interface IDispatchProps {
  onClose: () => void;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onClose: () => {
    dispatch(actions.updateHasSeenStaysFilterFtux(true));
  },
});

interface IOwnProps {
  anchorRef?: React.RefObject<HTMLElement | null>;
}

const mergeProps = (
  stateProps: IStateProps,
  dispatchProps: IDispatchProps,
  ownProps: IOwnProps
) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type StayTypeFilterPopoverConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedStayTypeFilterPopover = connector(
  ManagedStayTypeFilterPopover
);
